import {inlineError, tracer} from '@s-ui/decorators/lib'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class UpdateDataUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.getCurrentUserService
   * @param {RequestFactory} deps.updateDataUserRequestFactory
   * @param {Service} deps.updateCurrentUserService
   * @param {ErrorFactory} deps.userNotLoggedInUserErrorFactory
   * @param {Repository} deps.userRepository
   */
  constructor({
    getCurrentUserService,
    updateDataUserRequestFactory,
    updateCurrentUserService,
    userNotLoggedInUserErrorFactory,
    userRepository
  }) {
    super()
    this._getCurrentUserService = getCurrentUserService
    this._updateDataUserRequestFactory = updateDataUserRequestFactory
    this._updateCurrentUserService = updateCurrentUserService
    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
    this._userRepository = userRepository
  }

  /**
   * @return {Promise<Object, Error>} returns current logged user
   * @property {Object} user
   */

  @tracer({metric: 'UpdateDataUserUseCase#execute'})
  @inlineError
  async execute({useNewEndpoint, userData}) {
    const userEntity = await this._getCurrentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this._userNotLoggedInUserErrorFactory({
          message: 'To update personal data the user must be logged in'
        }).toJSON()
      )

    const updateDataUserRequest = this._updateDataUserRequestFactory(userData)

    const [error, updateCurrentUserRequest] = await this._userRepository.updateUserData({
      updateDataUserRequest,
      useNewEndpoint,
      userEntity
    })

    if (error) return Promise.reject(error)

    return this._updateCurrentUserService
      .execute({
        shouldReadUpdatedVO: useNewEndpoint,
        updateCurrentUserRequest
      })
      .then(userEntity => (userEntity ? userEntity.toJSON() : null))
  }
}
